import { http, HttpResponse } from 'msw'

import { allProducts } from '@/mocks/data/catalogue/products'
import { allSites } from '@/mocks/data/park/sites'

import { isNumeric } from '@/utils/app/number'
import { api, pause } from '@/utils/constants'
import { searchParametersSiteApi } from '@/utils/park/site'

import { SitesRequest } from '@/types/park/site'

export const getAllSites = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.sites.LIST}`,
    async ({ request }) => {
        const url = new URL(request.url)

        const limitQuery = url.searchParams.get('limit')
        const offsetQuery = url.searchParams.get('offset')

        const hasOrderQuery = url.searchParams.get(
            searchParametersSiteApi.HAS_ORDER,
        )

        let allSiteFiltered = allProducts

        // Has order filter
        if (hasOrderQuery) {
            allSiteFiltered = allSites.filter(
                (site) => site.has_order === (hasOrderQuery === 'true'),
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray = Math.min(allSiteFiltered.length, offset + limit)
        const results = allSiteFiltered.slice(offset, limitArray)

        await pause(1_000)

        const next =
            offset + results.length < allSiteFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<SitesRequest>({
            next,
            results,
        })
    },
)
